import React, {
  createContext,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";

const CartContext = createContext();

const CartProvider = ({ children }) => {
  const [order, setOrder] = useState([]);

  /**
   *
   * @param {*} product
   * @param {*} type - add | subtract
   */
  const genericAddOrSubtract = (product, type = "add") => {
    // Check if the product already exists in the state
    const index = order.findIndex(
      (item) => item.product && isEqual(item.product, product)
    );
    if (index !== -1) {
      // If the product already exists, increment qty
      setOrder((prevData) => {
        const newData = [...prevData];
        if (type === "add") {
          newData[index].qty += 1;
        } else {
          newData[index].qty -= 1;
        }
        return newData;
      });
    } else {
      // If the product does not exist, add it to the state
      setOrder((prevData) => [...prevData, { qty: 1, product: product }]);
    }
  };

  const addProduct = (newProduct) => {
    genericAddOrSubtract(newProduct);
  };

  const subtractProduct = (newProduct) => {
    genericAddOrSubtract(newProduct, "subtract");
  };

  const removeProductById = (productId) => {
    setOrder((prevData) =>
      prevData.filter((item) => item.product.id !== productId)
    );
  };

  const getTotalQuantity = () => {
    return order.reduce((total, item) => total + item.qty, 0);
  };

  const getTotalValue = () => {
    return order.reduce(
      (total, item) => total + item.qty * item.product.price,
      0
    );
  };

  // Function to check if two objects are equal
  const isEqual = (obj1, obj2) => {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  };

  useEffect(() => {
    localStorage.setItem("order", JSON.stringify(order));
  }, [order]);

  useLayoutEffect(() => {
    const orderFromStorage = localStorage.getItem("order");
    if (orderFromStorage) {
      setOrder(JSON.parse(orderFromStorage));
    }
  }, []);

  return (
    <CartContext.Provider
      value={{
        order,
        getTotalQuantity,
        getTotalValue,
        addProduct,
        subtractProduct,
        removeProductById,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export { CartContext };

export default CartProvider;
